/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var radio = require('ES/lib/radio');
var _ = require('ES/lib/lodash');

var esUtils = require('ES/utils/esUtils');
var FormMixin = require('ES/widgets/forms/FormMixin');
var HorizontalFields = require('ES/widgets/HorizontalFields');
var FormUtils = require('../../../../../utils/FormUtils');

module.exports = dd.createClass({
	__onSubmit: function(data){
		var event = _.cloneDeep(this.props.event);
		var ground = this.props.data;
		var onCancel = this.props.onCancel;

		if(!_.isArray(event.Ground)){
			event.Ground = [];
		}
		if(!ground || ground.id < 1){
			ground = {id: 0, eid: event.eid};
			event.Ground.push(ground);
		}
		_.each(event.Ground, function(g){
			if(g.id == ground.id){
				g.description = data.description;
				g.transportmode = data.transportmode;
				g.confirmation = data.confirmation;
				g.pickupinstructions = data.pickupinstructions;
				g.cost = FormUtils.floatOr0(data.cost);
				g.payment = data.payment;
				g.starttime = data.starttime;
			}
		});
		radio('save_Event').broadcast(event);
		if(_.isFunction(onCancel)){
			onCancel();
		}
	},
	__onDelete: esUtils.wrapPreventDefault(function(){
		var event = _.cloneDeep(this.props.event);
		var ground = this.props.data;
		var onCancel = this.props.onCancel;

		if(ground && ground.id > 0){
			event.Ground = _.reject(event.Ground, function(g){
				return ground.id == g.id;
			});
			radio('save_Event').broadcast(event);
		}
		if(_.isFunction(onCancel)){
			onCancel();
		}
	}),
	render: function(){
		return DaForm(_.assign({onSubmit: this.__onSubmit, onDelete: this.__onDelete}, this.props));
	}
});

var DaForm = dd.createClass({
	mixins: [FormMixin],
	getInitialValues: function(props){
		var ground = props.data;
		return ground && ground.id > 0 ? {
			description: ground.description,
			transportmode: ground.transportmode,
			confirmation: ground.confirmation,
			pickupinstructions: ground.pickupinstructions,
			cost: ground.cost,
			payment: ground.payment,
			starttime: ground.starttime
		} : null;
	},
	buildFields: function(){
		return {
			description: {
				label: 'Description',
				type: 'text',
				placeholder: 'Airport to hotel',
				validate: FormUtils.require
			},
			transportmode: {
				label: 'Transportation mode',
				type: 'text',
				placeholder: 'taxi',
				validate: FormUtils.optional
			},
			confirmation: {
				label: 'Conf #',
				type: 'text',
				validate: FormUtils.v.limitInputLength(20)
			},
			pickupinstructions: {
				label: 'Pickup Instructions',
				type: 'text',
				placeholder: 'driver with sign',
				validate: FormUtils.optional
			},
			cost: {
				label: 'Cost',
				type: 'text',
				validate: FormUtils.v.blankOr(FormUtils.v.currency)
			},
			payment: {
				label: 'Payment',
				type: 'combo',
				placeholder: '-select-',
				options: {
					PREPAID: "PREPAID",
					CASH: "CASH",
					CARD: "CARD",
					"N/A": ""
				},
				validate: FormUtils.optional
			},
			starttime: {
				label: 'Start time',
				type: 'date',
				pick_time: true
			}
		};
	},
	render: function(){
		var fields = this.buildFields();
		var errors = this.state.errors || {};

		var ground = this.props.data;
		var onCancel = this.props.onCancel;
		var onDelete = this.props.onDelete;
		var layout = [
			['description'],
			['starttime'],
			['transportmode', 'confirmation'],
			['pickupinstructions'],
			['cost', 'payment']
		];

		return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
			HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput,
				layout: layout
			}),
			HorizontalFields.FormButtons({
				scale: 'md',
				submit_btn_text: ground && ground.id > 0 ? 'Save' : 'Add',
				onCancel: onCancel,
				onDelete: ground && ground.id > 0 ? onDelete : null,
				right_align_buttons: true
			})
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/travel/GroundForm.js